import {registerGraph, mergeGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('evcsGraph', evcsGraph);

/* @ngInject */
function evcsGraph(GraphService, locale, defaultGraph) {
    const GraphColors = GraphService.colors;

    const colors = [
        {
           label: 'blue',
           value: GraphColors.blue
        },
        {
           label: 'red',
           value: GraphColors.red
        },
        {
           label: 'orange',
           value: GraphColors.orange
        },
        {
           label: 'green',
           value: GraphColors.green
        },
        {
           label: 'indigo',
           value: GraphColors.indigo
        }
     ]

    return mergeGraph(defaultGraph(), {
        size: {
            height: null,
        },
        options: {
            chart: {
                type: 'column',
                spacingLeft: 20,
                spacingRight: 20,
                plotBackgroundColor: '#F0EFEB',
                marginBottom: 70, // to make space for longer time labels i.e. '17. Aug 02:00'
                marginLeft: 48, // to have the width of the left axis panel fixed
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    pointPadding: 0,
                    groupPadding: 0.05,
                    borderWidth: 1,
                    borderColor: '#F0EFEB',
                    className: 'highcharts-stacked-graph'
                }
            },
            tooltip: GraphService.getTooltipFormatterWithTotal([0, 1, 2, 3, 4], locale.getString('graph.kwh'))
        },
        xAxis: {
            type: 'datetime',
            labels: {formatter: GraphService.datetimeLabeler()},
            startOfWeek: 1,
            lineWidth: 0,
        },
        yAxis: [
            {
                title: {
                    text: locale.getString('graph.kwh'),
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 5
                },
                gridLineWidth: 0,
                showFirstLabel: true
            }
        ],
        series: [],
        getSeriesByInstanceIds: function (instanceIds) {
            return instanceIds.map((instanceId, i) => ({
                instance: instanceId,
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter()
                },
                visible: true,
                data: [],
                total: 0,
                index: 0,
                name: `${locale.getString('graph.evcs')} ${i + 1}`,
                stack: instanceIds.length <= 3 ? `evcs_${i + 1}` : 'evcs',
                index: i,
                color: colors[i % colors.length].value,
                colorName: colors[i % colors.length].label,
            }));
        },
    });
}
